var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrintTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print_ticket",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 34,
    height: 34,
    transform: "translate(1113 652)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 25.722,
    height: 24.03,
    transform: "translate(-2 -2)",
    fill: "#b7b7b7",
    stroke: "#b7b7b7",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_51",
    "data-name": "Mask Group 51",
    transform: "translate(-1113 -652)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(1119 658.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M21.72,6.3a1.552,1.552,0,0,0-1.684-1.673H17.756V4.371q0-1.771,0-3.542c0-.6-.227-.828-.835-.828H4.788c-.593,0-.824.228-.824.818q0,1.761,0,3.521v.288H3.73c-.679,0-1.358.017-2.036,0A1.571,1.571,0,0,0,.023,5.909c0,.012-.015.023-.024.034V14.81a1.883,1.883,0,0,0,.459.866,1.61,1.61,0,0,0,1.156.445H3.963v.274q0,1.411,0,2.821c0,.58.233.815.806.815H16.945c.576,0,.81-.233.811-.81q0-1.41,0-2.821v-.279h2.28a1.556,1.556,0,0,0,1.684-1.675q0-4.073,0-8.145M5.294,1.324H16.43V4.618H5.294ZM16.429,18.708H5.29V12.224h11.14Zm3.645-3.9q-1.071,0-2.142,0h-.176v-.285c0-.947,0-1.895,0-2.842,0-.548-.241-.786-.791-.786H4.749c-.546,0-.784.241-.786.792q0,1.421,0,2.842v.266c-.08,0-.142.012-.2.012q-1.05,0-2.1,0c-.286,0-.346-.062-.346-.35q0-4.082,0-8.165c0-.289.059-.349.345-.349H20.066c.276,0,.339.061.339.333q0,4.093,0,8.186c0,.276-.064.343-.331.344",
    transform: "translate(0.001 0)",
    fill: "#b7b7b7",
    stroke: "#b7b7b7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M266.665,122.98a.943.943,0,0,0-.931.931.932.932,0,1,0,.931-.931",
    transform: "translate(-249.568 -115.498)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M119.28,223.159c.989.006,1.978,0,2.968,0s1.964,0,2.946,0a.658.658,0,1,0-.021-1.312c-.989,0-1.978,0-2.968,0-.954,0-1.908,0-2.862,0a.673.673,0,0,0-.684.4.648.648,0,0,0,.621.909",
    transform: "translate(-111.387 -208.35)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M125.213,264.853c-.982-.006-1.964,0-2.946,0h-1.25c-.586,0-1.173-.005-1.759.005a.64.64,0,0,0-.639.633.652.652,0,0,0,.589.661,1.767,1.767,0,0,0,.232.012q2.819,0,5.637,0a1.683,1.683,0,0,0,.3-.021.611.611,0,0,0,.5-.437.645.645,0,0,0-.658-.851",
    transform: "translate(-111.402 -248.737)",
    fill: "#b7b7b7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrintTicket);
export default __webpack_public_path__ + "static/media/icon_print_ticket.fc3ec077ad16d3fed3f8aa83478e8eb6.svg";
export { ForwardRef as ReactComponent };